import {REACT_APP_API_EMS_URL} from "../../config";
import {OffPeakEnergyStrategy} from "../../interfaces/ems/PlantEnergyStrategy";
import authenticatedApi from "../AuthenticatedApi";

const baseUrl = REACT_APP_API_EMS_URL;

const offPeakStrategyEndpoint = "/strategy/off-peak";

const apiEms = {
  getOffPeakStrategy: async (plantId: number): Promise<OffPeakEnergyStrategy | null> => {
    const url = `${baseUrl}${offPeakStrategyEndpoint}/${plantId}`;
    const response = await authenticatedApi.get(url, false);
    return response.json();
  },
  updateOffPeakStrategy: async (strategy: OffPeakEnergyStrategy): Promise<Response> => {
    const url = `${baseUrl}${offPeakStrategyEndpoint}/${strategy.plant_id}`;
    return await authenticatedApi.post(url, {...strategy});
  },
};

export default apiEms;
